<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="selectedLocation"
        color="primary"
        dark v-model="status"
        block 
        v-bind="attrs"
        v-on="on"
      >
      <v-icon v-if="attrs['aria-expanded'] === 'true'" >mdi-chevron-down</v-icon>
      <v-icon v-else >mdi-chevron-right</v-icon>
     
        {{ selectedLocation.name }}
      </v-btn>
     
    </template>
    <v-list>
      
      <v-list-item
        @click="selectLocation(item)"
        v-for="(item, index) in recentLocation"
        :key="index"
      >
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import authService from "@/modules/Authentication/service.js";
import { mapActions } from 'vuex';

export default {
  name: "lcoation-change",
  props: ["location"],
  data: (vm) => ({
    status:false,
    recentLocation: [],
    selectedLocation: vm.location,
    locationCode: null,
    deviceCode: null,
    deviceName: null,
  }),
  created() {
    this.recentLocation = JSON.parse(
      localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`
      )
    );
    if (!this.recentLocation) this.recentLocation = [];
    // console.log(
    //   "recentLocationrecentLocationrecentLocation",
    //   this.recentLocation
    // );
  },
  methods: {
    ...mapActions("employee", ["setEmployee"]),
    btnIcon(obj) {
      let value = 'mdi-chevron-right'
      if (obj['aria-expanded']) {
        console.log('in true')
        value = 'mdi-chevron-down'
      } else {
        console.log('in false')
        value = 'mdi-chevron-right'
      }
      console.log('tesetet', obj, value)
      return value
    },
    async selectLocation(location) {
      // console.log("location", location);
      if (location.pin) {
        await this.checkLocationCode(location);
        await this.login(location);
      } else {
        this.$toast.error("Authentication Needed", { timeout: 3000 });
        this.$router.push({ path: "/location" });
      }
    },
    checkLocationCode(location) {
      authService
        .getLocation(location.code)
        .then((response) => {
          this.selectedLocation = response.data;
          // this.setRecentLocation(this.location);
          localStorage.setItem(
            `${process.env.VUE_APP_STORAGE_PREFIX}location`,
            JSON.stringify(this.selectedLocation)
          );

          localStorage.setItem(
            `${process.env.VUE_APP_STORAGE_PREFIX}code`,
            location.code
          );
        })
        .catch((error) => {
          if (error) {
            switch (error.status) {
              case 404:
                this.$swal("Location", "Code Not Found", "error");
                break;
              default:
              // do nothing
            }
          }
        });
    },
    login(location) {
      const { deviceName, deviceCode } = authService.getStoredDevice();
      const loginInfo = {
        id: location.employeeId,
        pin: location.pin,
        locationCode: location.code,
        deviceCode: deviceCode,
        deviceName: deviceName,
      };
      authService
        .authenticate(loginInfo)
        .then(async (response) => {
          console.log('switch location response', response)
          // this.loading = false;
          await localStorage.setItem(
            `${process.env.VUE_APP_STORAGE_PREFIX}Hometoken`,
            this.generateTimeClockToken()
          );

          this.$emit('submit')
          authService.setLastEmployeeId(response.data.employee.id);
          this.setEmployee(response.data.employee);
          // this.setRecentLocation();
          // await this.updateEmployee();
          // await this.$router.push({ name: "home" });
        })
        .catch((error) => {
          console.log('error on login', error)
          // this.loading = false;
          // this.$Progress.fail();
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
          this.$router.push({ name: "authentication-find-location" });
        });
    },
    generateTimeClockToken() {
      let rand = function () {
        return Math.random().toString(36).substr(2);
      };

      return rand() + rand();
    },
  },
};
</script>

<style scoped>
</style>